var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('newslettertopsection'),_c('svg-top-gradient'),_c('travelssection',{attrs:{"lang":_vm.$ml.current}}),_c('newsletterbottomsection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }